<template>
<div id="app">
  <div v-if="user.logedin" class="ui inverted menu">
    <router-link class="item" to="/operations">
      <a>Operationen</a>
    </router-link>
    <router-link class="item" to="/touren">
      <a>Touren</a>
    </router-link>
    <div class="right menu">
      <router-link class="item" to="/documentation">
        <a>Dokumentation</a>
      </router-link>
    </div>
  </div>
  <div style="margin:auto; max-width: 840px; padding: 30px;">
    <router-view></router-view>
  </div>
</div>
</template>

<script>
import Login from './components/Login.vue'
import Dashboard from './components/Dashboard.vue'
import Documentation from './components/Documentation.vue'
import User from './enteties/User'

export default {
  name: 'app',
  components: {
    Login,
    Dashboard,
    Documentation
  },
  data: function() {
    return {
      user: User
    }
  },
  created: function() {

    if (!this.user.logedin) {
      this.$router.push({
        path: 'login'
      })
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

button {
  text-decoration: none;
  text-align: center;
  appearance: none;
  background: 0 0;
  margin: 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-family: inherit;
  cursor: pointer;
  outline: 0;
  box-sizing: border-box;
  vertical-align: middle;
  border: 1px solid #cccccc;
  font-size: var(--f7-button-font-size);
  color: var(--f7-button-text-color, var(--f7-theme-color));
  height: var(--f7-button-height);
  line-height: calc(var(--f7-button-height) - var(--f7-button-border-width, 0) * 2);
  padding: 4px 8px;
  border-radius: 4px;
  min-width: 90px;
  font-weight: var(--f7-button-font-weight);
  letter-spacing: var(--f7-button-letter-spacing);
  text-transform: var(--f7-button-text-transform);
  background-color: var(--f7-button-bg-color);
  box-shadow: var(--f7-button-box-shadow);
}

button:hover {
  background-color: #eeeeee;
}

.dg-content {
  font-size: 16px;
  line-height: 1.3em;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
}

.dg-btn {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
}
</style>
